// "You signed up in the app, but the confirmation link opened Safari."
//
// The iOS app's own origin can't be opened from an email, so its confirmation
// link goes to the web app (signupCompletion.js, confirmRedirect). Safari gets
// the session; the app has none. Until Universal Links exist, the web app
// tells an iPhone visitor who just confirmed that they can go back to the app.
//
// Read at import: supabase-js removes the #…type=signup hash once it has
// processed it, and that happens asynchronously, after module evaluation.
import { Capacitor } from '@capacitor/core';

const KEY = 'confirmed_in_browser';

const arrived = typeof window !== 'undefined'
  && /(^#|&)type=signup(&|$)/.test(window.location.hash);

if (arrived) {
  try { sessionStorage.setItem(KEY, '1'); } catch { /* private mode: `arrived` still covers this load */ }
}

export function shouldShowConfirmedNote() {
  if (Capacitor.isNativePlatform()) return false;
  // iPhone only: the app is iPhone-only and there is no Android app yet.
  if (!/iPhone|iPod/.test(navigator.userAgent)) return false;
  try { return sessionStorage.getItem(KEY) === '1'; } catch { return arrived; }
}

export function dismissConfirmedNote() {
  try { sessionStorage.removeItem(KEY); } catch { /* nothing to clear */ }
}
